import { render, staticRenderFns } from "./SetTel.vue?vue&type=template&id=9263f090&scoped=true"
import script from "./SetTel.vue?vue&type=script&lang=js"
export * from "./SetTel.vue?vue&type=script&lang=js"
import style0 from "./SetTel.vue?vue&type=style&index=0&id=9263f090&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9263f090",
  null
  
)

export default component.exports